import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Box, Button, DialogActions, DialogContent, Dialog, DialogTitle, Typography, Checkbox, FormControlLabel } from "@mui/material";
import NotaryCard2 from "../Common/NotaryCard2";
import { CheckTexVal, ValidateEmail } from "../Common/helpers";

export default function InviteNotaryDialog(props) {
	console.log(props)
	const [state, setState] = useState({});
	const [complete, setComplete] = useState(false);
	const handleClose = () => {
		props.onClose();
	};
	const handleChange = (event) => {
		setState({ ...state, [event.target.name]: event.target.value });
	};
	const handleChangeCheckbox = (event) => {
		setState({ ...state, [event.target.name]: event.target.checked });
	};
	const handleNotaryInvite = () => {
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(state),
		};
		fetch("/api/893a97dfea8d47a59bfc2365c5e87895/" + props.state.uid, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":

						switch (props.state.side) {
							case "VN":
								window.location.href = "/11d1355181ac4376a09980601b420617/" + props.state.uid;
								break;

							case "AC":
								window.location.href = "/1fdf58e512f54752959b369588380557/" + props.state.uid;
								break;

						}
						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};
	useEffect(() => {
		if (CheckTexVal(state.notary_fname)
			&& CheckTexVal(state.notary_raison_sociale)
			&& CheckTexVal(state.notary_lname)
			&& ValidateEmail(state.notary_email)
			&& state.loc_ntr) {
			setComplete(true);
		} else {
			setComplete(false);
		}
	}, [state])
	return (
		<Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog">
				<Typography variant="h5" gutterBottom>
					Inviter un notaire
				</Typography>
			</DialogTitle>
			<DialogContent dividers>
				<NotaryCard2 state={state} handleChange={handleChange} />
				{/* <div>
					<FormControlLabel
						control={<Checkbox checked={state.my_notary} onChange={handleChangeCheckbox} name="follow_up" color="primary" />}
						label="En faire mon notaire par défaut"
					/>
				</div> */}
			</DialogContent>
			<DialogActions>
				<Box display="flex" justifyContent="space-between" style="width: 100%">
					<Box>
						<Button onClick={handleClose}>Annuler</Button>
					</Box>
					<Box>
						<Button
							variant="contained"
							onClick={handleNotaryInvite}
							disabled={!complete}>
							Inviter
						</Button>
					</Box>
				</Box>
			</DialogActions>
		</Dialog>
	);
}
